var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conOfHeaderPages"},[_c('div',{staticClass:"sectionHeader mianTitleResposive"},[_c('span',[_vm._v(" "+_vm._s(_vm.headerPage.part1)+" ")]),_vm._v(" "+_vm._s(_vm.headerPage.part2)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }